"use strict";
exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map


//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/rxjs@5.5.12/~/rxjs/util/isArrayLike.js
// module id = ../../../../../../rxjs@5.5.12/node_modules/rxjs/util/isArrayLike.js
// module chunks = 4